module.exports = __webpack_public_path__ + "img/face-7.8a4e3407.jpg";